import React, { Component } from 'react';
import { setState } from './lib/state'
import { logPath } from './lib/path'
import getInitialState from './initial-state'
import Quiz from './Quiz.jsx'
import t from './translate/t'

class App extends Component {
  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent.bind(this)
    logPath()
  }

  onBackButtonEvent(event) {
    if (event.state) {
      setState(event.state)
    } else {
      setState(getInitialState())
    }
  }

  setLanguage(event, language) {
    if (event.metaKey) {
      return
    }
    event.preventDefault()

    setState({ language })
  }

  reset() {
    setState(getInitialState())
    window.history.pushState(false, false, '/')
  }

  render() {
    const { language } = this.props
    const activeFi = language === 'fi' ? 'active' : ''
    const activeEn = language === 'en' ? 'active' : ''

    return <div id="app" className="bg-white flex flex-col">
        <div className="header flex flex-row px-2">
            <h1 className="flex-1 mb-0" onClick={() => this.reset()}>pikavaalikone eduskunta 2019</h1>
            <div className="text-right -mx-2 select-none">
              <a href="/" className={"link mx-2 " + activeFi} onClick={event => this.setLanguage(event, 'fi')}>Fi</a>
              <a href="/en/" className={"link " + activeEn} onClick={event => this.setLanguage(event, 'en')}>En</a>
              <span className="button mx-2" onClick={() => this.reset()}>{t('reset')}</span>
            </div>
        </div>
        <Quiz {...this.props} />
    </div>
  }
}
          {/*<p>{t('about')}</p>*/}

export default App;
